import React, { useContext, useEffect, useState } from "react";
import {
  DefaultDate,
  HTTPResponse,
  PageDesignConstants,
  SideMenuItems,
  ToastMessageType,
  ToastMessages,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import DateControl from "../../Components/DateControl";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import {
  CommonError_Msgs,
  CommonMsgs,
  HRU_MSGS,
} from "../../Helpers/HelperText";
import ErrorField from "../../Components/ErrorField";
import {
  AllowOnlyIntegers,
  GetDisplayDate,
  GetLocalStorageData,
  GetLoggedInUserID,
  GetOrdinal,
  IsAfterIndex,
  IsDateBefore,
  IsDateEmpty,
  IsDateValid,
  IsMonthUnk,
  IsOnOrAfterDate,
  IsOnOrAfterIndex,
  ParseDate,
  SetDateState,
  ValueInRange,
  isStringEmpty,
} from "../../Helpers/Utilities";
import { HruService } from "../../WebApiServices/Hru.service";
import { AppContext } from "../../Contexts/AppContextProvider";
const HealthcareResourceUtilization = () => {
  const {
    ShowToast,
    ToggleLoader,
    ShowActionPopUp,
    HandleSessionTimeout,
    appState,
  } = useContext(AppContext);

  const { tmtAfterEpcoLOTCnt } = appState ?? 0;
  const navigatePaths = {
    prevPage: appState.showCartPage
      ? "/CARTCellTherapy"
      : tmtAfterEpcoLOTCnt == 0
        ? "/Epcoritamab"
        : `/TreatmentsAfterEpcoritamab/${tmtAfterEpcoLOTCnt}`,
    currPage: "/HRU",
    nextPage: "/ValidateSubmit",
  };
  // const pid = GetLocalStorageData("patientId") ?? 0;
  const patientId = GetLocalStorageData("patientId");

  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);
  const surveyDate = patientData?.surveyDate ?? "";

  const [indexDate, setIndexDate] = useState("");
  const [lbclDate, setLbclDate] = useState("");
  const [chartAbstractionDate, setChartAbstractionDate] = useState("");
  const [death_Date, set_Death_Date] = useState("");
  const [epcor_dis_date, setEpcor_dis_date] = useState("");
  const [secondChartAbstractDate, setSecondChartAbstractDate] = useState("");

  const InitialSoftErrList = {
    q94HospitalizationUnk_err: false,
    q95ERvisitsUnk_err: false,
    q96LbclUnk_err: false,
    q97renalUnk_err: false,
    q98liverUnk_err: false,
  };

  const InitialHardErrList = {
    q94hospitalizationEmpty: false,
    q94ValueTxtEmpty: false,
    q94SizeRangeLimHard: false,

    q95ERvisitsEmpty: false,
    q95ERvisitsTxtEmpty: false,
    q95SizeRangeLimHard: false,

    q96LbclEmpty: false,
    q96LbclTxtEmpty: false,
    q96SizeRangeLimHard: false,

    q97renalEmpty: false,
    q97renalTxtEmpty: false,
    q97SizeRangeLimHard: false,

    q98liverEmpty: false,
    q98liverTxtEmpty: false,
    q98SizeRangeLimHard: false,
  };

  const [softErrList, setSoftErrList] = useState(InitialSoftErrList);
  const [hardErrList, setHardErrList] = useState(InitialHardErrList);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  const [hruDetails, setHruDetails] = useState({
    //94
    q94_hospitalization_txt: "",
    q94_hospitalization_Unk: null,

    //95
    q95_ER_Visits_txt: "",
    q95_ER_Visits_Unk: null,

    //96
    q96_outpatient_visits_txt: "",
    q96_outpatient_visits_Unk: null,

    //97
    q97_renal_tests_txt: "",
    q97_renal_tests_Unk: null,

    //98
    q98_liver_tests_txt: null,
    q98_liver_tests_Unk: null,
  });

  const HandleFieldChange = (e) => {
    const { name, id, value, checked } = e.target;

    switch (name) {
      //94
      case "q94_hospitalization_Unk": {
        setHruDetails((prev) => ({
          ...prev,
          [name]: Number(value), //value,
          q94_hospitalization_txt: "",
        }));

        setSoftErrList((prev) => ({
          ...prev,
          q94HospitalizationUnk_err: parseInt(value) === 99,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q94hospitalizationEmpty: false,
          q94ValueTxtEmpty: false,
          q94SizeRangeLimHard: false,
        }));
        break;
      }

      case "q94_hospitalization_txt": {
        if (value !== "" && !AllowOnlyIntegers(value)) {
          break;
        }
        setHruDetails((prev) => ({
          ...prev,
          [name]: value,
          q94_hospitalization_Unk: 1,
        }));

        setSoftErrList((prev) => ({
          ...prev,
          q94HospitalizationUnk_err: false,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q94hospitalizationEmpty: false,
          q94ValueTxtEmpty: false,
          q94SizeRangeLimHard: false,
        }));

        break;
      }

      //95
      case "q95_ER_Visits_Unk": {
        setHruDetails((prev) => ({
          ...prev,
          [name]: Number(value), //value,
          q95_ER_Visits_txt: "",
          //  emergency_visit:null
        }));

        setSoftErrList((prev) => ({
          ...prev,
          q95ERvisitsUnk_err: parseInt(value) === 99,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q95ERvisitsEmpty: false,
          q95ERvisitsTxtEmpty: false,
          q95SizeRangeLimHard: false,
        }));
        break;
      }

      case "q95_ER_Visits_txt": {
        if (value !== "" && !AllowOnlyIntegers(value)) {
          break;
        }
        setHruDetails((prev) => ({
          ...prev,
          [name]: value,
          q95_ER_Visits_Unk: 1,
        }));

        setSoftErrList((prev) => ({
          ...prev,
          q95ERvisitsUnk_err: false,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q95ERvisitsEmpty: false,
          q95ERvisitsTxtEmpty: false,
          q95SizeRangeLimHard: false,
        }));

        break;
      }

      //96
      case "q96_outpatient_visits_Unk": {
        setHruDetails((prev) => ({
          ...prev,
          [name]: Number(value), //value,
          q96_outpatient_visits_txt: "",
        }));

        setSoftErrList((prev) => ({
          ...prev,
          q96LbclUnk_err: parseInt(value) === 99,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q96LbclEmpty: false,
          q96LbclTxtEmpty: false,
          q96SizeRangeLimHard: false,
        }));
        break;
      }

      case "q96_outpatient_visits_txt": {
        if (value !== "" && !AllowOnlyIntegers(value)) {
          break;
        }
        setHruDetails((prev) => ({
          ...prev,
          [name]: value,
          q96_outpatient_visits_Unk: 1,
        }));

        setSoftErrList((prev) => ({
          ...prev,
          q96LbclUnk_err: false,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q96LbclEmpty: false,
          q96LbclTxtEmpty: false,
          q96SizeRangeLimHard: false,
        }));

        break;
      }

      //97
      case "q97_renal_tests_Unk": {
        setHruDetails((prev) => ({
          ...prev,
          [name]: Number(value), //value,
          q97_renal_tests_txt: "",
        }));

        setSoftErrList((prev) => ({
          ...prev,
          q97renalUnk_err: parseInt(value) === 99,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q97renalEmpty: false,
          q97renalTxtEmpty: false,
          q97SizeRangeLimHard: false,
        }));

        break;
      }

      case "q97_renal_tests_txt": {
        if (value !== "" && !AllowOnlyIntegers(value)) {
          break;
        }
        setHruDetails((prev) => ({
          ...prev,
          [name]: value,
          q97_renal_tests_Unk: 1,
        }));

        setSoftErrList((prev) => ({
          ...prev,
          q97renalUnk_err: false,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q97renalEmpty: false,
          q97renalTxtEmpty: false,
          q97SizeRangeLimHard: false,
        }));

        break;
      }

      //98
      case "q98_liver_tests_Unk": {
        setHruDetails((prev) => ({
          ...prev,
          [name]: Number(value), //value,
          q98_liver_tests_txt: "",
        }));

        setSoftErrList((prev) => ({
          ...prev,
          q98liverUnk_err: parseInt(value) === 99,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q98liverEmpty: false,
          q98liverTxtEmpty: false,
          q98SizeRangeLimHard: false,

          liverLbclEmptyHard: false,
          liverAfter_dt_Ca_EmptyHard: false,
          liverDxEmptyHard: false,
        }));

        break;
      }

      case "q98_liver_tests_txt": {
        if (value !== "" && !AllowOnlyIntegers(value)) {
          break;
        }

        const intValue = Number(value);
        setHruDetails((prev) => ({
          ...prev,
          [name]: intValue,
          q98_liver_tests_Unk: 1,
        }));

        setSoftErrList((prev) => ({
          ...prev,
          q98liverUnk_err: false,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q98liverEmpty: false,
          q98liverTxtEmpty: false,
          q98SizeRangeLimHard: false,
        }));

        break;
      }
      default:
        break;
    }
  };

  const SavePage = async (validate) => {
    try {
      ToggleLoader(true);
      setSoftErrList(InitialSoftErrList);
      setHardErrList(InitialHardErrList);

      let isValid = validate ? ValidateForm() : true;

      if (isValid) {
        setShowTopErrMsg(false);

        const hruModel = {
          patientId: patientId,
          //94
          Hospitalization: hruDetails.q94_hospitalization_Unk,
          noOfHospitalization: hruDetails.q94_hospitalization_txt,

          //95
          ErVisits: hruDetails.q95_ER_Visits_Unk,
          noOfErVisits: hruDetails.q95_ER_Visits_txt,

          //96
          OutpatientVisits: hruDetails.q96_outpatient_visits_Unk,
          noOfOutpatientVisits: hruDetails.q96_outpatient_visits_txt,

          //97
          RenalfunctionTests: hruDetails.q97_renal_tests_Unk,
          noOfRenalfunctionTests: hruDetails.q97_renal_tests_txt,

          //98
          LiverfunctionTests: hruDetails.q98_liver_tests_Unk,
          noOfLiverfunctionTests: hruDetails.q98_liver_tests_txt,

          createdby: GetLoggedInUserID() ?? 0,
          editedby: GetLoggedInUserID() ?? 0,
          userId: GetLoggedInUserID(),
          isValidated: validate,
        };
        if (patientId > 0) {
          const response = await HruService.SaveHRUDetails(hruModel);
          ToggleLoader(false);
          if (response.status !== HTTPResponse.OK) {
            if (response?.status === HTTPResponse.Unauthorized) {
              HandleSessionTimeout();
            } else throw response.error;
          } else {
            await LoadData();
            ToggleLoader(false);
            ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
          }
        }
        return true;
      } else {
        ToggleLoader(false);
        setShowTopErrMsg(true);
        return false;
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  useEffect(() => {
    async function FetchData() {
      if (!isNaN(patientId) && Number(patientId) !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const LoadData = async () => {
    try {
      if (patientId > 0) {
        const response = await HruService.GetAllHRUDetails(patientId);
        if (response?.status === HTTPResponse.OK) {
          const { data } = response;
          setHruDetails((prev) => ({
            ...prev,
            userId: data.userId,

            q94_hospitalization_Unk: data.hospitalization,
            q94_hospitalization_txt: data.noOfHospitalization,

            q95_ER_Visits_txt: data.noOfErVisits,
            q95_ER_Visits_Unk: data.erVisits,

            q96_outpatient_visits_txt: data.noOfOutpatientVisits,
            q96_outpatient_visits_Unk: data.outpatientVisits,

            q97_renal_tests_txt: data.noOfRenalfunctionTests,
            q97_renal_tests_Unk: data.renalfunctionTests,

            q98_liver_tests_txt: data.noOfLiverfunctionTests,
            q98_liver_tests_Unk: data.liverfunctionTests,
          }));

          if (data.lbclDate) {
            setLbclDate(data.lbclDate);
          }

          if (data.chartAbstractDate) {
            setChartAbstractionDate(data.chartAbstractDate);
          }

          if (data.deathDate) {
            set_Death_Date(data.deathDate);
          }

          if (data.indexDate) {
            setIndexDate(data.indexDate);
          }

          if (data.epcoDiscontinueDate) {
            setEpcor_dis_date(data.epcoDiscontinueDate);
          }
          if (data.secondChartAbstractDate) {
            setSecondChartAbstractDate(data.secondChartAbstractDate);
          }
        } else if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  };

  const ValidateForm = () => {
    let isValid = true;

    // Validation for q94
    if (hruDetails.q94_hospitalization_Unk === null) {
      setHardErrList((prev) => ({
        ...prev,
        q94hospitalizationEmpty: true,
      }));
      isValid = false;
    }

    if (
      hruDetails.q94_hospitalization_Unk === 1 &&
      hruDetails.q94_hospitalization_txt === ""
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q94ValueTxtEmpty: true,
      }));
      isValid = false;
    }

    if (
      hruDetails.q94_hospitalization_Unk === 1 &&
      hruDetails.q94_hospitalization_txt != "" &&
      (Number(hruDetails.q94_hospitalization_txt) < 0 ||
        Number(hruDetails.q94_hospitalization_txt) > 1000)
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q94SizeRangeLimHard: true,
      }));
      isValid = false;
    }

    // Validation for q95
    if (hruDetails.q95_ER_Visits_Unk === null) {
      setHardErrList((prev) => ({
        ...prev,
        q95ERvisitsEmpty: true,
      }));
      isValid = false;
    }

    if (
      hruDetails.q95_ER_Visits_Unk === 1 &&
      hruDetails.q95_ER_Visits_txt === ""
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q95ERvisitsTxtEmpty: true,
      }));
      isValid = false;
    }

    if (
      hruDetails.q95_ER_Visits_Unk === 1 &&
      hruDetails.q95_ER_Visits_txt != "" &&
      (Number(hruDetails.q95_ER_Visits_txt) < 0 ||
        Number(hruDetails.q95_ER_Visits_txt) > 1000)
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q95SizeRangeLimHard: true,
      }));
      isValid = false;
    }

    //Validation for 96
    if (hruDetails.q96_outpatient_visits_Unk === null) {
      setHardErrList((prev) => ({
        ...prev,
        q96LbclEmpty: true,
      }));
      isValid = false;
    }

    if (
      hruDetails.q96_outpatient_visits_Unk === 1 &&
      hruDetails.q96_outpatient_visits_txt === ""
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q96LbclTxtEmpty: true,
      }));
      isValid = false;
    }

    if (
      hruDetails.q96_outpatient_visits_Unk === 1 &&
      hruDetails.q96_outpatient_visits_txt != "" &&
      (Number(hruDetails.q96_outpatient_visits_txt) < 0 ||
        Number(hruDetails.q96_outpatient_visits_txt) > 1000)
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q96SizeRangeLimHard: true,
      }));
      isValid = false;
    }

    //Validation for 97
    if (hruDetails.q97_renal_tests_Unk === null) {
      setHardErrList((prev) => ({
        ...prev,
        q97renalEmpty: true,
      }));
      isValid = false;
    }

    if (
      hruDetails.q97_renal_tests_Unk === 1 &&
      hruDetails.q97_renal_tests_txt === ""
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q97renalTxtEmpty: true,
      }));
      isValid = false;
    }

    if (
      hruDetails.q97_renal_tests_Unk === 1 &&
      hruDetails.q97_renal_tests_txt != "" &&
      (Number(hruDetails.q97_renal_tests_txt) < 0 ||
        Number(hruDetails.q97_renal_tests_txt) > 1000)
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q97SizeRangeLimHard: true,
      }));
      isValid = false;
    }

    //Validation for 98
    if (hruDetails.q98_liver_tests_Unk === null) {
      setHardErrList((prev) => ({
        ...prev,
        q98liverEmpty: true,
      }));
      isValid = false;
    }

    if (
      hruDetails.q98_liver_tests_Unk === 1 &&
      hruDetails.q98_liver_tests_txt === ""
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q98liverTxtEmpty: true,
      }));
      isValid = false;
    }

    if (
      hruDetails.q98_liver_tests_Unk === 1 &&
      hruDetails.q98_liver_tests_txt != "" &&
      (Number(hruDetails.q98_liver_tests_txt) < 0 ||
        Number(hruDetails.q98_liver_tests_txt) > 1000)
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q98SizeRangeLimHard: true,
      }));
      isValid = false;
    }

    return isValid;
  };
console.log("njkh",epcor_dis_date)
  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>

      <section className="main-survey-section">
        <div className="row">
          <SideBarMenu activePageId={SideMenuItems.HRU} />

          <div className="col-md-9 col-pad-left">
            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4>HEALTHCARE RESOURCE UTILIZATION (HRU) </h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div className="survey-question-section">
                <div className="survey-question-content">
                  <div style={PageDesignConstants.PageDescriptionStyle}>
                    <i className="instruction-text-font">
                      In this section, you will be asked to enter the patient’s
                      total number of DLBCL-related hospitalizations, emergency
                      room (ER), outpatient visits, and renal and liver tests
                      from the index date, {""}
                      <span style={{ color: PageDesignConstants.fontColor }}>
                        {indexDate}
                      </span>{" "}
                      to <b>the end of epcoritamab use in the real world</b>{" "}
                      <span style={{ color: PageDesignConstants.fontColor }}>
                        {/* {epcor_dis_date} || {surveyDate} */}
                        {epcor_dis_date
                          ? epcor_dis_date
                          : secondChartAbstractDate
                            ? secondChartAbstractDate
                            : surveyDate}
                      </span>
                      . DLBCL-related hospitalizations, ER visits, and
                      outpatient visits are any visits associated with DLBCL
                      symptoms, disease progression, or DLBCL treatment.
                    </i>
                  </div>
                  <div className="question-answer">
                    <div className="vertical-pad-15">
                      <span className="text-spacing">
                        <b> Hospitalizations </b>
                      </span>
                    </div>
                    <div
                      className="question-bot-sapce"
                      style={{ paddingBottom: "10px" }}
                    >
                      <div className="question question-weight">
                        <span>Q113.</span>
                        <span className="quest-text-pad">
                          Number of hospitalizations related to DLBCL: {""}
                        </span>
                      </div>
                      <div className="double-dig-answer">
                        <div className="">
                          <label>
                            <input
                              type="radio"
                              id="q94hospitalization_1"
                              name="q94_hospitalization_Unk"
                              value={1}
                              checked={hruDetails.q94_hospitalization_Unk === 1}
                              onChange={HandleFieldChange}
                            />
                            <span className="quest-text-pad radio-text-padding">
                              <input
                                className="sub-input-dash "
                                name="q94_hospitalization_txt"
                                type="text"
                                value={hruDetails.q94_hospitalization_txt}
                                maxLength={8}
                                onChange={HandleFieldChange}
                              />
                            </span>
                          </label>
                        </div>

                        <div className="option-without-input">
                          <label>
                            <input
                              type="radio"
                              id="q94_Unk_select_99"
                              name="q94_hospitalization_Unk"
                              value={99}
                              checked={
                                hruDetails.q94_hospitalization_Unk === 99
                              }
                              onChange={HandleFieldChange}
                            />
                            <span className="radio-text-padding">Unknown</span>
                          </label>
                        </div>
                      </div>
                      <ErrorField
                        show={hardErrList.q94hospitalizationEmpty}
                        message={HRU_MSGS.q94hospitalizationEmpty}
                      />
                      <ErrorField
                        show={hardErrList.q94ValueTxtEmpty}
                        message={HRU_MSGS.q94ValueTxtEmpty}
                      />
                      <ErrorField
                        show={softErrList.q94HospitalizationUnk_err}
                        message={CommonMsgs.Unknown}
                      />
                      <ErrorField
                        show={hardErrList.q94SizeRangeLimHard}
                        message={HRU_MSGS.RangeLimit}
                      />
                    </div>
                    {/* Q99-102 Set1 start */}

                    {/* Q99-102 Set2 end */}
                    <div className="vertical-pad-15">
                      <span className="text-spacing">
                        <b> Emergency room (ER) visits </b>
                      </span>
                    </div>
                    <div
                      className="question-bot-sapce"
                      style={{ paddingBottom: "10px" }}
                    >
                      <div className="question question-weight">
                        <span>Q114.</span>
                        <span className="quest-text-pad">
                          Number of ER visits related to DLBCL: {""}
                        </span>
                      </div>
                      <div className="double-dig-answer">
                        <div className="">
                          <label>
                            <input
                              type="radio"
                              id="q95Unk"
                              name="q95_ER_Visits_Unk"
                              value={1}
                              checked={hruDetails.q95_ER_Visits_Unk === 1}
                              onChange={HandleFieldChange}
                            />

                            <span className="quest-text-pad radio-text-padding">
                              <input
                                className="sub-input-dash "
                                name="q95_ER_Visits_txt"
                                type="text"
                                value={hruDetails.q95_ER_Visits_txt}
                                maxLength={8}
                                onChange={HandleFieldChange}
                              />
                            </span>
                          </label>
                        </div>

                        <div className="option-without-input">
                          <label>
                            <input
                              type="radio"
                              id="q95Unk"
                              name="q95_ER_Visits_Unk"
                              value={99}
                              checked={hruDetails.q95_ER_Visits_Unk === 99}
                              onChange={HandleFieldChange}
                            />

                            <span className="radio-text-padding">Unknown</span>
                          </label>
                        </div>
                      </div>
                      <ErrorField
                        show={hardErrList.q95ERvisitsEmpty}
                        message={HRU_MSGS.q95ERvisitsEmpty}
                      />
                      <ErrorField
                        show={softErrList.q95ERvisitsUnk_err}
                        message={CommonMsgs.Unknown}
                      />
                      <ErrorField
                        show={hardErrList.q95ERvisitsTxtEmpty}
                        message={HRU_MSGS.q95ERvisitsTxtEmpty}
                      />
                      <ErrorField
                        show={hardErrList.q95SizeRangeLimHard}
                        message={HRU_MSGS.RangeLimit}
                      />
                    </div>

                    {/* Q103-104 Set2 end */}

                    <div className="vertical-pad-15">
                      <span className="text-spacing">
                        <b>Outpatient visits </b>
                      </span>
                    </div>
                    <div
                      className="question-bot-sapce"
                      style={{ paddingBottom: "10px" }}
                    >
                      <div className="question question-weight">
                        <span>Q115.</span>
                        <span className="quest-text-pad">
                          Number of outpatient visits related to DLBCL: {""}
                        </span>
                      </div>
                      <div className="double-dig-answer">
                        <div className="">
                          <label>
                            <input
                              type="radio"
                              id="q96Unk"
                              name="q96_outpatient_visits_Unk"
                              value={1}
                              checked={
                                hruDetails.q96_outpatient_visits_Unk === 1
                              }
                              onChange={HandleFieldChange}
                            />

                            <span className="quest-text-pad radio-text-padding">
                              <input
                                className="sub-input-dash "
                                name="q96_outpatient_visits_txt"
                                type="text"
                                value={hruDetails.q96_outpatient_visits_txt}
                                maxLength={8}
                                onChange={HandleFieldChange}
                              />
                            </span>
                          </label>
                        </div>

                        <div className="option-without-input">
                          <label>
                            <input
                              type="radio"
                              id="q96Unk"
                              name="q96_outpatient_visits_Unk"
                              value={99}
                              checked={
                                hruDetails.q96_outpatient_visits_Unk === 99
                              }
                              onChange={HandleFieldChange}
                            />

                            <span className="radio-text-padding">Unknown</span>
                          </label>
                        </div>
                      </div>
                      <ErrorField
                        show={hardErrList.q96LbclEmpty}
                        message={HRU_MSGS.q96Outpatientvisits}
                      />
                      <ErrorField
                        show={hardErrList.q96LbclTxtEmpty}
                        message={HRU_MSGS.q96OutpatientvisitsTxtEmpty}
                      />
                      <ErrorField
                        show={softErrList.q96LbclUnk_err}
                        message={CommonMsgs.Unknown}
                      />
                      <ErrorField
                        show={hardErrList.q96SizeRangeLimHard}
                        message={HRU_MSGS.RangeLimit}
                      />
                    </div>

                    <div className="vertical-pad-15">
                      <span className="text-spacing">
                        <b>Lab tests </b>
                      </span>
                    </div>

                    <div
                      className="question-bot-sapce"
                      style={{ paddingBottom: "10px" }}
                    >
                      <div className="question question-weight">
                        <span>Q116.</span>
                        <span className="quest-text-pad">
                          Number of renal function tests undergone by patient:{" "}
                          {""}
                        </span>
                      </div>
                      <div className="double-dig-answer">
                        <div className="">
                          <label>
                            <input
                              type="radio"
                              id="q97Unk"
                              name="q97_renal_tests_Unk"
                              value={1}
                              checked={hruDetails.q97_renal_tests_Unk === 1}
                              onChange={HandleFieldChange}
                            />

                            <span className="quest-text-pad radio-text-padding">
                              <input
                                className="sub-input-dash "
                                name="q97_renal_tests_txt"
                                type="text"
                                value={hruDetails.q97_renal_tests_txt}
                                maxLength={8}
                                onChange={HandleFieldChange}
                              />
                            </span>
                          </label>
                        </div>

                        <div className="option-without-input">
                          <label>
                            <input
                              type="radio"
                              id="q97Unk"
                              name="q97_renal_tests_Unk"
                              value={99}
                              checked={hruDetails.q97_renal_tests_Unk === 99}
                              onChange={HandleFieldChange}
                            />

                            <span className="radio-text-padding">Unknown</span>
                          </label>
                        </div>
                      </div>
                      <ErrorField
                        show={hardErrList.q97renalEmpty}
                        message={HRU_MSGS.q97LabTests}
                      />
                      <ErrorField
                        show={hardErrList.q97renalTxtEmpty}
                        message={HRU_MSGS.q97LabTestsTxtEmpty}
                      />
                      <ErrorField
                        show={softErrList.q97renalUnk_err}
                        message={CommonMsgs.Unknown}
                      />
                      <ErrorField
                        show={hardErrList.q97SizeRangeLimHard}
                        message={HRU_MSGS.RangeLimit}
                      />
                    </div>

                    <div
                      className="question-bot-sapce"
                      style={{ paddingBottom: "10px" }}
                    >
                      <div className="question question-weight">
                        <span>Q117.</span>
                        <span className="quest-text-pad">
                          Number of liver function tests undergone by patient:{" "}
                          {""}
                        </span>
                      </div>
                      <div className="double-dig-answer">
                        <div className="">
                          <label>
                            <input
                              type="radio"
                              id="q98Unk"
                              name="q98_liver_tests_Unk"
                              value={1}
                              checked={hruDetails.q98_liver_tests_Unk === 1}
                              onChange={HandleFieldChange}
                            />

                            <span className="quest-text-pad radio-text-padding">
                              <input
                                className="sub-input-dash "
                                name="q98_liver_tests_txt"
                                type="text"
                                value={hruDetails.q98_liver_tests_txt}
                                maxLength={8}
                                onChange={HandleFieldChange}
                              />
                            </span>
                          </label>
                        </div>

                        <div className="option-without-input">
                          <label>
                            <input
                              type="radio"
                              id="q98Unk"
                              name="q98_liver_tests_Unk"
                              value={99}
                              checked={hruDetails.q98_liver_tests_Unk === 99}
                              onChange={HandleFieldChange}
                            />

                            <span className="radio-text-padding">Unknown</span>
                          </label>
                        </div>
                      </div>
                      <ErrorField
                        show={hardErrList.q98liverEmpty}
                        message={HRU_MSGS.q98liverEmpty}
                      />
                      <ErrorField
                        show={hardErrList.q98liverTxtEmpty}
                        message={HRU_MSGS.q98liverTxtEmpty}
                      />
                      <ErrorField
                        show={softErrList.q98liverUnk_err}
                        message={CommonMsgs.Unknown}
                      />
                      <ErrorField
                        show={hardErrList.q98SizeRangeLimHard}
                        message={HRU_MSGS.RangeLimit}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default HealthcareResourceUtilization;
